export interface Est3WbsLayer {
  id: string;
  code: string;
  name: string;
  description?: string | null;
  depth_order: number;
  parent_layer_id?: string | null;
  sort_order?: number;
}

export const WBS_LAYER_HINTS: Record<string, string> = {
  PROJECT: 'Level 0 — entire project scope',
  UNIT: 'Level 1 — major operating subdivision',
  AREA: 'Level 2 — geographic / Construction Work Area (CWA)',
  BLOCK: 'Level 3 — distinct structure or major equipment grouping',
  MODULE: 'Level 4 — fabricatable or independently executable chunk',
  PACKAGE: 'Level 5 — lowest executable work package (CWP)',
};

export const WBS_COST_ATTACHMENT_LAYER = 'PACKAGE';

export function layerLabel(layer?: Est3WbsLayer | null): string {
  if (!layer) return '—';
  return `${layer.code} · ${layer.name}`;
}

export function allowedChildLayers(
  layers: Est3WbsLayer[],
  parentLayerId?: string | null
): Est3WbsLayer[] {
  if (!parentLayerId) {
    return layers.filter((l) => Number(l.depth_order) === 0);
  }
  const parent = layers.find((l) => l.id === parentLayerId);
  if (!parent) return [];
  const childDepth = Number(parent.depth_order) + 1;
  return layers.filter((l) => Number(l.depth_order) === childDepth);
}

export function isWbsLeafNode(
  nodeId: string,
  nodes: Array<{ id: string; parent_id?: string | null; parentId?: string | null }>
): boolean {
  return !nodes.some((n) => String(n.parent_id || n.parentId || '') === nodeId);
}

export function nodesWithChildren(
  nodes: Array<{ id: string; parent_id?: string | null; parentId?: string | null }>
): Set<string> {
  const parents = new Set<string>();
  for (const n of nodes) {
    const pid = n.parent_id || n.parentId;
    if (pid) parents.add(String(pid));
  }
  return parents;
}

export function layerCodeFromNode(node: Record<string, unknown>): string {
  return String(node.layer_code || node.wbs_layer_code || '');
}
